module.exports = __webpack_public_path__ + "static/example-image-4-3a16173a4b3ce29797c7f6eca89f0ec2.jpg";